"use client"
// Το @windmill/react-ui αφαιρέθηκε 5 Νοε 2026 (ευπάθεια deepmerge, ασύμβατο με React 19).
// Ο provider έβαζε μόνο την κλάση "dark" στο <html>, που δεν χρησιμοποιείται πουθενά.
export default function Providers({ children }: { children: React.ReactNode }) {
  return <>{children}</>
}
